module.exports = __webpack_public_path__ + "img/generaxion-white.815ac7bf.svg";